import React from 'react';
import { Circle } from 'react-leaflet';
import { getHelmFor } from '@compass/data/maps/helm';
import { useMapDescriptor } from '@compass/hooks/useMapDescriptor';
import { useMapSettings } from '@compass/stores/useMapSettings';
import { useMap } from './MapContext';

const helmColor = 'var(--gray)';

export function Helm(): React.ReactElement<{}, typeof Helm> {
  const showHelm = useMapSettings((s) => s.settings.get('showHelm'));
  const { name } = useMapDescriptor();
  const { image } = useMap();

  const helm = getHelmFor(name);

  return (
    <>
      {showHelm && (
        <>
          {helm.map((point, idx) => (
            <Circle
              bubblingMouseEvents={false}
              center={point.toLatLng(image)}
              key={idx}
              pathOptions={{
                color: helmColor,
                fill: true,
                fillOpacity: 1.0,
              }}
              radius={4}
            />
          ))}
        </>
      )}
    </>
  );
}
